import React, { FC, useEffect, useState } from "react";
import { Table, Spin, Badge, Select, Input, Row, Col } from "antd";
import { NavLink } from "react-router-dom";
import { Text3D } from "../Text3D";
import { useLazyQuery } from "@apollo/client";
import moment from "moment";
import styled from "styled-components";
import { GET_ALL_ORDERS_FOR_ADMIN_V2 } from "../../Apollo/graphql/Query";
// import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
// import { EDIT_ORDER } from '../../Apollo/graphql/Mutation/OrderMutations';
const { Option } = Select;
const { Search } = Input;

const STATUS_COLOR = {
  PENDING_PAYMENT: "pink",
  CONFIRMED: "orange",
  PREPARED: "cyan",
  RECEIVED: "green",
  DELIVERED: "blue",
  CANCELLED: "volcano",
  REJECTED: "volcano",
  PAYMENT_FAILED: "volcano",
  FAILED: "volcano",
};

const OrderDetailWrapper = styled.div``;

const OrdersList: FC = () => {
  const [orders, setOrders] = useState();
  const [totalPage, setTotalPage] = useState<any>();
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [filterValue, setFilterValue] = useState<any>({
    material: [],
    status: "",
    search: "",
  });
  const [sortValue, setSortValue] = useState<any>("");
  // const [selectedMaterial, setSelectedMaterial] = useState<any>([])
  const PAGE_LIMIT = 10;

  // const [editOrderMutation] = useMutation(EDIT_ORDER);

  const columns = [
    {
      title: "Ordered By",
      dataIndex: "requestedByUser",
      key: "requestedByUser",
      width: 50,
      render: (requestedByUser) => (
        // eslint-disable-next-line
        <a>
          {requestedByUser?.firstName || ""} {requestedByUser?.lastName || ""}
        </a>
      ),
    },
    {
      title: "Order UID:",
      dataIndex: "_id",
      key: "_id",
      width: 120,
      render: (_id) => (
        <div
          style={{
            wordWrap: "break-word",
            wordBreak: "break-word",
            width: 120,
          }}
        >
          {_id}
        </div>
      ),
    },
    {
      title: "Order No:",
      dataIndex: "platformOrderNo",
      key: "platformOrderNo",
      ellipsis: true,
    },
    // { title: "Qty", dataIndex: "quantity", key: "quantity" },
    // {
    //   title: "Material",
    //   dataIndex: "material",
    //   key: "material",
    //   render: (material) => (
    //     <span>
    //       {material === "PLA_PLUS" ? "PLA+" : material.split("_").join(" ")}
    //     </span>
    //   ),
    // },
    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      render: (grossTotal) => (
        <Text3D textSize="0.9rem" textWeight={600} textColor="#1196DD">
          AU$ {grossTotal}
        </Text3D>
      ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   width: 150,
    //   render: (status) => (
    //     <span>
    //       <Badge status={StatusColors[status] || "volcano"} />
    //       {status.split("_").join(" ")}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Shipping Tracking Id",
    //   dataIndex: "shippingId",
    //   key: "shippingId",
    // },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (createdAt) => (
        <span>{moment(createdAt).format("YYYY-MM-DD, h:mm:ss a")}</span>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 150,
      render: (updatedAt) => (
        <span>{moment(updatedAt).format("YYYY-MM-DD, h:mm:ss a")}</span>
      ),
    },
    // {
    //   title: "Printing Price",
    //   dataIndex: "printingPrice",
    //   key: "printingPrice",
    //   render: (printingPrice) => <span>${printingPrice}</span>,
    // },
    // {
    //   title: "Design Price",
    //   dataIndex: "designPrice",
    //   key: "designPrice",
    //   render: (designPrice) => <span>${designPrice}</span>,
    // },
    // {
    //   title: "Design",
    //   children: [
    //     {
    //       title: "DesignId",
    //       dataIndex: "design",
    //       key: "designId",
    //       width: 50,
    //       render: (design) => (
    //         <div
    //           style={{
    //             wordWrap: "break-word",
    //             wordBreak: "break-word",
    //             width: 120,
    //           }}
    //         >
    //           {design?._id}
    //         </div>
    //       ),
    //     },
    //     {
    //       title: "Name",
    //       dataIndex: "design",
    //       key: "designName",
    //       width: 50,
    //       render: (design) => <span>{design?.name}</span>,
    //     },
    //   ],
    // },
    // {
    //   title: "Printer",
    //   children: [
    //     {
    //       title: "Id",
    //       dataIndex: "printer",
    //       key: "printerId",
    //       width: 50,
    //       render: (printer) => (
    //         <div
    //           style={{
    //             wordWrap: "break-word",
    //             wordBreak: "break-word",
    //             width: 120,
    //           }}
    //         >
    //           {printer?._id}
    //         </div>
    //       ),
    //     },
    //     {
    //       title: "Printer Name",
    //       dataIndex: "printer",
    //       key: "printerName",
    //       width: 50,
    //       render: (printer) => <span>{printer?.name}</span>,
    //     },
    //     {
    //       title: "Printer Owner",
    //       dataIndex: "requestedForUser",
    //       key: "ownerName",
    //       width: 50,
    //       render: (requestedForUser) => (
    //         // eslint-disable-next-line
    //         <a>
    //           {requestedForUser?.firstName} {requestedForUser?.lastName}
    //         </a>
    //       ),
    //     },
    //  ],
    // },
  ];

  const [getOrders, { loading }] = useLazyQuery(GET_ALL_ORDERS_FOR_ADMIN_V2, {
    onCompleted: (data) => {
      setOrders(data?.allOrdersV2?.orders);
      setTotalPage(data?.allOrdersV2?.pagination?.total);
    },
    onError: (err) => {
      console.log("Order couldn't fetch");
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    const variables = {};
    variables["pagination"] = {
      page: currentPage,
      limit: PAGE_LIMIT,
    };
    if (sortValue.startsWith("price")) {
      variables["sort"] = {
        grossTotal: sortValue.split("_")[1],
      };
    }
    if (sortValue.startsWith("create")) {
      variables["sort"] = {
        createdAt: sortValue.split("_")[1],
      };
    }
    if (sortValue.startsWith("update")) {
      variables["sort"] = {
        updatedAt: sortValue.split("_")[1],
      };
    }
    // if (filterValue.material?.length > 0 || filterValue.search !== null) {
    //   variables['filter'] = {
    //     material: filterValue.material,
    //     search: filterValue.search
    //   }
    // }
    if (filterValue.status === "ALL" || filterValue.status === "") {
      variables["filter"] = {
        search: filterValue.search,
      };
    } else {
      variables["filter"] = {
        status: filterValue.status,
        search: filterValue.search,
      };
    }

    getOrders({ variables: { ...variables } });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortValue, filterValue, currentPage]);

  const handleInputSearch = (value) => {
    setFilterValue({ ...filterValue, search: value });
  };

  const renderOrderDetail = (order) => {
    return (
      <OrderDetailWrapper>
        {order.packages.map((singlePackage, pdx) => {
          return (
            <div className="order-package">
              <Row>
                <Col span={6}>
                  <div className="package-seller">
                    <div>
                      <Text3D textSize="0.8rem" textWeight={600}>
                        Package: {pdx + 1}
                      </Text3D>
                    </div>
                    <div>
                      <Text3D textSize="0.8rem" textWeight={600}>
                        Seller:{" "}
                        {`${singlePackage?.requestedForUser?.firstName || ""} ${
                          singlePackage?.requestedForUser?.lastName || ""
                        }`}
                      </Text3D>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="package-type">
                    <div>
                      <Text3D textSize="0.8rem" textWeight={600}>
                        Delivery Type: {singlePackage.deliveryType}
                      </Text3D>
                    </div>
                    {singlePackage.deliveryType &&
                      singlePackage.deliveryType === "PICKUP" && (
                        <div>
                          <Text3D textSize="0.8rem" textWeight={600}>
                            Pickup Location:{" "}
                            {singlePackage.shippingDetail.fromLocation
                              ? `${
                                  singlePackage.shippingDetail.fromAddress ||
                                  "-"
                                },${singlePackage.shippingDetail.from || "-"},${
                                  singlePackage.shippingDetail.fromLocation ||
                                  ""
                                },${
                                  singlePackage.shippingDetail.fromState || ""
                                },${
                                  singlePackage.shippingDetail.countryCode || ""
                                }`
                              : singlePackage.items[0]?.printer
                                  ?.postalAddress || ""}
                          </Text3D>
                        </div>
                      )}
                    {singlePackage.deliveryType &&
                      singlePackage.deliveryType === "SHIPPING" && (
                        <div>
                          <Text3D textSize="0.8rem" textWeight={600}>
                            Ship to:{" "}
                            {`${order.shippingDetail.to || "-"}, ${
                              order.shippingDetail.deliveryLocation || "-"
                            }, ${
                              order.shippingDetail.deliveryAddress || "-"
                            }, ${order.shippingDetail.deliveryState || "-"}, ${
                              order.shippingDetail.overseas
                                ? order.shippingDetail.countryCode || ""
                                : "AU"
                            }`}
                            <br />
                            Ship From: {""}
                            {singlePackage.shippingDetail.fromLocation
                              ? `${
                                  singlePackage.shippingDetail.fromAddress ||
                                  "-"
                                },${singlePackage.shippingDetail.from || "-"},${
                                  singlePackage.shippingDetail.fromLocation ||
                                  ""
                                },${
                                  singlePackage.shippingDetail.fromState || ""
                                },${
                                  singlePackage.shippingDetail.countryCode || ""
                                }`
                              : singlePackage.items[0]?.printer
                                  ?.postalAddress || ""}
                          </Text3D>
                        </div>
                      )}
                  </div>
                </Col>
                <Col span={12}>
                  <div className="package-status-wrapper">
                    {singlePackage.deliveryType &&
                      singlePackage.deliveryType !== "PICKUP" && (
                        <>
                          <div style={{ marginRight: "6px" }}>
                            <Text3D textSize="0.8rem" textWeight={600}>
                              Tracking No:
                            </Text3D>
                            <Text3D textSize="0.8rem" textWeight={600}>
                              {singlePackage.shippingId || " Not Set"}
                            </Text3D>
                          </div>
                        </>
                      )}
                  </div>

                  <div className="package-price-wrapper">
                    <Text3D
                      textSize="0.9rem"
                      textWeight={600}
                      style={{ marginRight: "8px" }}
                    >
                      Shipping Price
                    </Text3D>
                    <Text3D
                      textSize="0.9rem"
                      textWeight={600}
                      textColor="#1196DD"
                      style={{ marginRight: "8px" }}
                    >
                      AU$ {singlePackage.shippingPrice}
                    </Text3D>
                    <Text3D
                      textSize="0.9rem"
                      textWeight={600}
                      style={{ marginRight: "8px" }}
                    >
                      Seller Total
                    </Text3D>
                    <Text3D
                      textSize="0.9rem"
                      textWeight={600}
                      textColor="#1196DD"
                    >
                      AU$ {singlePackage.grossSellerTotal}
                    </Text3D>
                  </div>
                </Col>
              </Row>
              {singlePackage.items.map((item, idx) => {
                return (
                  <div className="order-item">
                    <Row>
                      <Col span={24}>
                        <div className="single-item-wrapper" key={idx}>
                          <Row>
                            <Col span={8}>
                              <div>
                                <div>
                                  <span style={{ color: "#757575" }}>
                                    Design: {""}
                                  </span>
                                  <NavLink to={`/design/${item.designId}`}>
                                    {item?.design?.name || ""}
                                  </NavLink>
                                </div>
                                <div>
                                  <span style={{ color: "#757575" }}>
                                    Printer:{" "}
                                  </span>
                                  <NavLink
                                    to={`/printers/${item?.printerId || ""}`}
                                  >
                                    {item?.printer?.name || ""}
                                  </NavLink>
                                </div>
                              </div>
                            </Col>
                            <Col span={16}>
                              <Row>
                                <Col span={16}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-evenly",
                                    }}
                                  >
                                    <div>
                                      <span>Quantity: </span>
                                      <span>{item.quantity}</span>
                                    </div>
                                    <div>
                                      <span>Infill: </span>
                                      <span>{item.infill}</span>
                                    </div>
                                    <div>
                                      <span>Scale: </span>
                                      <span>{item.scale}</span>
                                    </div>
                                    <div>
                                      <span>Material: </span>
                                      <span>{item.material}</span>
                                    </div>
                                    <div>
                                      <span>Color: </span>
                                      <span>{item.color}</span>
                                    </div>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div className="status-price-wrapper">
                                    <div>
                                      <Badge
                                        count={item.status}
                                        style={{
                                          backgroundColor:
                                            STATUS_COLOR[item.status] ||
                                            STATUS_COLOR["DEFAULT"],
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </div>
          );
        })}
      </OrderDetailWrapper>
    );
  };

  return (
    <Spin spinning={loading}>
      <Table
        key="loading-done"
        bordered
        title={() => (
          <div
            style={{
              display: "flex",
              flexFlow: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <p style={{ marginBottom: 0 }}>Filter By:</p>
              <div
                style={{
                  display: "flex",
                  flexFlow: "row",
                  gap: "1rem",
                  justifyContent: "space-between",
                }}
              >
                {/* <Select
                  placeholder={
                    selectedMaterial?.length !== 0
                      ? `${selectedMaterial?.toString()}`
                      : `Materials`
                  }
                  onChange={onChange}
                  dropdownMatchSelectWidth={false}
                  dropdownRender={() => (
                    <div>
                      <Checkbox.Group onChange={onCheckboxChange} defaultValue={selectedMaterial}>
                        <Space
                          direction="vertical"
                          style={{ padding: "0 10px" }}
                        >
                          <Checkbox value="ABS">ABS</Checkbox>
                          <Checkbox value="PLA">PLA</Checkbox>
                          <Checkbox value="PLA_PLUS">PLA+</Checkbox>
                          <Checkbox value="PET">PET</Checkbox>
                          <Checkbox value="PETG">PETG</Checkbox>
                          <Checkbox value="RESIN">RESIN</Checkbox>
                          <Checkbox value="NYLON">NYLON</Checkbox>
                          <Checkbox value="NYLON_CARBON_FIBER">
                            NYLON CARBON FIBER
                          </Checkbox>
                          <Checkbox value="TPU">TPU</Checkbox>
                          <Checkbox value="HIPS">HIPS</Checkbox>
                          <Checkbox value="PVA">PVA</Checkbox>
                          <Checkbox value="SANDSTONE">SANDSTONE</Checkbox>
                          <Checkbox value="CERAMICS">CERAMICS</Checkbox>
                          <Checkbox value="STEEL">STEEL</Checkbox>
                          <Checkbox value="WOOD">WOOD</Checkbox>
                        </Space>
                      </Checkbox.Group>
                    </div>
                  )}
                ></Select> */}
                <Select
                  placeholder={"Status"}
                  dropdownMatchSelectWidth={false}
                  onChange={(value) => {
                    setCurrentPage(1);
                    setFilterValue({ ...filterValue, status: value });
                  }}
                >
                  <Option value="ALL">ALL</Option>
                  <Option value="PENDING_PAYMENT">PENDING PAYMENT</Option>
                  <Option value="CONFIRMED">CONFIRMED</Option>
                  <Option value="PREPARED">PREPARED</Option>
                  <Option value="RECEIVED">RECEIVED</Option>
                  <Option value="DELIVERED">DELIVERED</Option>
                  <Option value="CANCELLED">CANCELLED</Option>
                  <Option value="REJECTED">REJECTED</Option>
                  <Option value="PAYMENT_FAILED">PAYMENT FAILED</Option>
                  <Option value="FAILED">FAILED</Option>
                </Select>
              </div>
            </div>
            <Search
              placeholder="Search with Order No or Order UID"
              allowClear
              enterButton="Search"
              onSearch={handleInputSearch}
              style={{ width: "400px" }}
            />
            <Select
              placeholder={"Sort By"}
              dropdownMatchSelectWidth={false}
              onChange={(value) => setSortValue(value)}
            >
              <Option value="price_desc">Price - High to Low</Option>
              <Option value="price_asc">Price - Low to High</Option>
              <Option value="create_asc">Created At - Ascending</Option>
              <Option value="create_desc">Created At - Descending</Option>
              <Option value="update_asc">Updated At - Ascending</Option>
              <Option value="update_desc">Updated At - Descending</Option>
            </Select>
          </div>
        )}
        columns={columns}
        dataSource={orders}
        pagination={{
          position: ["bottomCenter"],
          current: currentPage,
          showSizeChanger: false,
          total: totalPage,
          defaultPageSize: PAGE_LIMIT,
          onChange: (page) => {
            setCurrentPage(page);
          },
        }}
        scroll={{ x: true, scrollToFirstRowOnChange: true }}
        expandable={{
          expandedRowRender: renderOrderDetail,
          // defaultExpandAllRows: true,
          // rowExpandable: (record) => record.name !== "Not Expandable",
        }}
      ></Table>
    </Spin>
  );
};

export default OrdersList;
